import React from 'react';
import './Product.css';

import { showErrorToast } from '../../components';
import { calculateAverageRating, useCart, useWishlist } from '../../utils';

import { FaStar } from 'react-icons/fa';
import { BsHeart, BsEye } from 'react-icons/bs';

import { Link } from 'react-router-dom';



const Product = ({ product, list }) => {

  // Destructuring product properties
  const { image, content, name, disprice, price} = product;

  // Calculate the average rating for the product
  const averageRating = calculateAverageRating(product);

  // Access cart and wishlist functions
  const { addToCart } = useCart();
  const { addToWishlist } = useWishlist();

  return ( 

    <div className='product-item'>

      <div className='image'>

        <div className='options'>

          {/* Add to Wishlist Button */}
          <Link to='/wishlist' onClick={() => addToWishlist(product)} data-tooltip="Add to Wishlist">
            <BsHeart />
          </Link>

          {/* View Product Details Button */}
          <Link to={`/Shop/${name}`} state={product} data-tooltip="View Details">
            <BsEye />
          </Link>

        </div>

        <img src={image} alt={name} /> {/* Product image */}

      </div>
 
      <div className='content'>

        {/* Star rating */}
        <div className='rating'>
          <div className='icon'>
            <FaStar /> <FaStar /> <FaStar /> <FaStar /> <FaStar />
          </div>
          {/* Display average rating and number of comments */}
          {product.comments.length > 0 ? (
            <h5> {averageRating} ({product.comments.length}) </h5>
          ) : (
            <h5>Not rated</h5>
          )}
        </div>

        {/* Product Name Link */}
        <Link
          to={{
            pathname: '/Shop/' + name,
          }}
          location={{ product }}
          state={product}><h3>{name}</h3> {/* Product name */}
        </Link> 

        {/* Product Description (conditionally rendered) */}
        {list && <p>{content}</p>} 

        {/* Discounted price and original price */}
        <div className='price'>
          <p>
            ${disprice > 0 ? disprice : price} {/* Use disprice if it's greater than 0, otherwise use price */}
            {disprice > 0 && <span>${price}</span>} {/* Show original price only if there's a discount */}
          </p>
        </div>

        {/* Add to Cart Button - Handles stock availability */}
        <Link
          to={product.stock > 0 ? "/cart" : "#"}
          className='btn'
          onClick={(e) => {
            if (product.stock > 0) {
              addToCart(product);
            } else {
              e.preventDefault();
              showErrorToast("This product is out of stock!");
            }
          }}
          data-tooltip={product.stock > 0 ? "Add to Cart" : "Out of Stock"}
        >
          Add To Cart
        </Link>

      </div>

    </div>
  );
};

export default Product;